import React from 'react';
import {
  Users, ArrowDownToLine, Coins, Bot, ArrowUpFromLine, CircleDollarSign, ShieldAlert,
} from 'lucide-react';
import { StatCard, Panel, Disclaimer } from '../../components/Primitives';
import { useFetch } from '../../lib/hooks';
import { fmtUsd } from '../../lib/api';

export default function AdminOverview() {
  const { data: o } = useFetch('/admin/overview', [], 20000);
  const s = o || {};
  return (
    <div className="space-y-6" data-testid="admin-overview">
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard label="Registered Users" value={s.users ?? '—'} accent="silver" icon={Users} />
        <StatCard label="Pending KYC" value={s.pending_kyc ?? '—'} accent="gold" icon={ShieldAlert} />
        <StatCard label="Pending Deposits" value={s.pending_deposits ?? '—'} accent="gold" icon={ArrowDownToLine} />
        <StatCard label="Verified Deposit Volume" value={fmtUsd(s.verified_deposit_volume)} accent="neon" icon={ArrowDownToLine} />
        <StatCard label="Approved Allocations" value={fmtUsd(s.approved_allocations)} accent="gold" icon={Coins} />
        <StatCard label="Active Bot Sessions" value={s.active_bots ?? '—'} accent="neon" icon={Bot} />
        <StatCard label="Pending Withdrawals" value={s.pending_withdrawals ?? '—'} accent="gold" icon={ArrowUpFromLine} />
        <StatCard label="Completed Withdrawals" value={s.completed_withdrawals ?? '—'} accent="emerald" icon={CircleDollarSign} />
      </div>
      <Disclaimer>Overview distinguishes real on-chain verified deposits from paper-trading and admin-recorded activity. Real exchange execution data is shown only when an exchange adapter is connected.</Disclaimer>
    </div>
  );
}
